import { useStoreState } from "../../store";

function useIsAuthorized() {
  const isAuthorized =  useStoreState((state) => state.auth.authorized);

  return isAuthorized
}

export default useIsAuthorized;
